import { useState } from "react"

export const useGlobalStates = () => {

    // formulario de datos (pantalla/modal de edición/ver datos)
    const [showForm, setShowForm] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE') // EDITABLE | READONLY

    // modal/pantalla de imágenes (si lo usas como modal aparte)
    const [showModalCollateralImages, setShowModalCollateralImages] = useState(false)
    const [collateralIdImages, setCollateralIdImages] = useState(0)

    // modo para la sección de imágenes (también aplica READONLY/EDITABLE)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')

    // navegación general
    const [showSection, setShowSection] = useState('HOME') // HOME | IMAGE

    // navegación de imágenes
    const [imagesCurrentIndex, setImagesCurrentIndex] = useState(0)

    // opcional
    const [openTarget, setOpenTarget] = useState('NONE')

    return Object.freeze({
        // datos
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,

        // imágenes (si lo necesitas)
        showModalCollateralImages, setShowModalCollateralImages,
        collateralIdImages, setCollateralIdImages,
        modalOpeningMode, setModalOpeningMode,

        // navegación
        showSection, setShowSection,

        // index imagen
        imagesCurrentIndex, setImagesCurrentIndex,

        // opcional
        openTarget, setOpenTarget,
    })
}